import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import Typography from '@mui/material/Typography';
import {Grid} from '@mui/material';
import Card from '@mui/material/Card';
import {GlassMagnifier} from 'react-image-magnifiers';
import {Images} from '../../../common/Assets/Images';
import Moment from 'react-moment';
import {useNavigate, useParams} from 'react-router';
import {loansAction} from '../../../services/LoanServices';
import LoanDetailAction from './LoanDetailAction';
import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import LoanAuditTrails from './LoanAuditTrails';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';

export default function LoanDetail(props) {
  const navigate = useNavigate();
  const [item, setItem] = useState({});
  const [changeIndex, setChangeIndex] = useState(0);
  const [openLog, setOpenLog] = useState(false);
  const dimensions = item?.catalogue?.dimensions || [];
  const params = useParams();
  const id = params?.id;

  const asText = (value) => {
    if (value === null || value === undefined) return '-';
    if (typeof value === 'object') {
      return value?.name || value?.code || value?.description || String(value?.id || '-');
    }
    const str = String(value);
    return str?.trim?.() ? str : '-';
  };

  useEffect(() => {
    getLoanDetail();
  }, []);

  const getLoanDetail = () => {
    loansAction('get', id).then(res => {
      setItem(res?.data);
    })
  }

  const formatDimensions = (dimensions) => {
    const width = dimensions?.find(dim => dim?.name === 'Width')?.value || 'N/A';
    const height = dimensions?.find(dim => dim?.name === 'Height')?.value || 'N/A';
    const length = dimensions?.find(dim => dim?.name === 'Length')?.value || 'N/A';

    return `${width}cm x ${height}cm x ${length}cm`;
  };

  const formatWeight = (dimensions) => {
    const weight = dimensions?.find(dim => dim?.name === 'Weight')?.value || 'N/A';

    return `${weight} kg`;
  };

  const handleSelectedIndex = (index) => {
    setChangeIndex(index);
  }

  const pdfDetail = (id) => {

  }

  const handleEdit = () => {
    navigate(`/management/artifact-managements/loan-update/?id=${id}`)
  }

  const toggleLog = () => {
    setOpenLog(!openLog);
  }

  const handleLogClose = () => {
    setOpenLog(false);
  }

  return (
    <PageWrapper>
      <Box className={'space-between'} sx={{marginTop: 5}}>
        <Box onClick={() => navigate(-1)}
             className={'flex-cx-center hand-cursor'}>
          <ArrowBackIosRoundedIcon fontSize={'small'} sx={{color: '#757575'}}/>
          <Typography variant={'h5'} sx={{color: '#757575'}}>Loan</Typography> &nbsp;
        </Box>
        <LoanDetailAction item={item} handleEdit={handleEdit} loanId={id}/>
      </Box>
      <Box className={'header-divider'}/>
      <Grid container spacing={2}>
        <Grid item sm={5} xs={12}>
          <Card className={'box-shadow'} sx={{width: '100%'}}>
            <GlassMagnifier
              imageSrc={item?.catalogue?.attachments?.[changeIndex]?.file || Images.logoWhite}
              imageAlt="Item Image"
              largeImageSrc={item?.catalogue?.attachments?.[changeIndex]?.file || Images.logoWhite}
              largeImageAlt="Zoomed Image"
              magnifierSize="40%"
              square
            />
          </Card>
          <Grid container spacing={1} sx={{mt: 0.5}}>
            {item?.catalogue?.attachments?.length > 0 && item?.catalogue?.attachments?.map((attachment, index) => (
              attachment.type !== 'application/pdf' && (
                <Grid item sm={2.4} key={index}>
                  <Card sx={{height: 100}}>
                    <img onClick={() => handleSelectedIndex(index)} draggable={false} width={'100%'} height={'100%'}
                         style={{borderRadius: 5, objectFit: 'contain'}}
                         src={attachment?.file || Images?.logoWhite}
                         alt="item_image"/>
                  </Card>
                </Grid>
              )
            ))}
          </Grid>
        </Grid>
        <Grid item sm={7} xs={12}>
          <Card className={'box-shadow'}>
            <Box sx={{p: 2}}>
              <Typography className={'font20 text-500 dark-color'}>Artefact Detail</Typography>
            </Box>
            <Box className={'common-divider'}/>
            <Box sx={{p: 2}}>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>OBJECT NAME:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.catalogue?.object_name}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>OWNERSHIP:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.ownership)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>ACCESSION NO: </Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.accession_no)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CLASSIFICATION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.object_group || item?.catalogue?.classification)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>OBJECT TYPE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.object_type || item?.catalogue?.object_type_legacy)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>SUB GROUP:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.object_sub_group || item?.catalogue?.sub_group)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>MATERIALS:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.material)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DIMENSIONS:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography
                    className={'font-15'}>{formatDimensions(dimensions)}, {formatWeight(dimensions)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DYES:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.dyes)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>MOTIFS:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.motifs)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DATE OF ACQUISITION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment
                    format={'ll'}>{item?.date_of_aquisition}</Moment></Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CONDITION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.condition)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>LOCATION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.storage_location || item?.catalogue?.location || item?.catalogue?.location_legacy)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>PLACE OF ORIGIN:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.place_of_origin)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>ADDITIONAL INFORMATION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{asText(item?.catalogue?.other_info)}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>CATALOGED BY:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.user_name}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DATE OF ENTRY:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment format={'ll'}>{item?.date_of_entry}</Moment></Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>PURPOSE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.purpose}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>AGENCY LOANED TO:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.agency_loaned_to}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>DURATION:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}>{item?.duration} {item?.duration_unit}</Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>ISSUE DATE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment format={'ll'}>{item?.issue_date}</Moment></Typography>
                </Grid>
              </Grid>
              <Grid container spacing={2} sx={{mb: 0.5}}>
                <Grid item sm={4}>
                  <Typography className={'dark-color font-15 text-500'}>RETURN DATE:</Typography>
                </Grid>
                <Grid item sm={8}>
                  <Typography className={'font-15'}><Moment format={'ll'}>{item?.return_date}</Moment></Typography>
                </Grid>
              </Grid>
              {item?.justification &&
              <Grid container spacing={2} sx={{mb: 0.5, mt: 1}}>
                <Grid item sm={12}>
                  <Typography className={'dark-color font-15 text-500 text-capitalize'}>Justification:</Typography>
                  <Typography className={'font-15'}>
                    {item?.justification}
                  </Typography>
                </Grid>
              </Grid>
              }
            </Box>
          </Card>
          <Card className={'box-shadow'} sx={{p: 2, mt: 1}}>
            <Typography className={'dark-color font-15 text-500'}>DESCRIPTION</Typography>
            <Typography className={'font-14'}>{asText(item?.catalogue?.description)}</Typography>
          </Card>
          <Card className={'box-shadow'} sx={{p: 2, mt: 1}}>
            <Typography className={'dark-color font-15 text-500 upper-case'}>Exhibition history</Typography>
            <Typography className={'font-14'}>{item?.catalogue?.exhibition_history}</Typography>
          </Card>
          <Card className={'box-shadow'} sx={{p: 2, mt: 1}}>
            <Typography className={'dark-color font-15 text-500'}>Loan Request Attachments</Typography>
            {item?.attachments?.length > 0 && item.attachments.map((attachment, index) => (
                <Box key={index} className={'hand-cursor font-15'}
                     onClick={() => pdfDetail(attachment?.id)}>
                  <a href={attachment?.file} target={'_blank'}>{attachment?.name} </a>
                </Box>
            ))}
          </Card>
        </Grid>
      </Grid>
      <Box sx={{position: 'fixed', right: 0, bottom: '10%'}}>
        <Card onClick={toggleLog} className={'box-shadow'}
              sx={{
                pr: 2.5,
                pl: 2,
                pt: 1.5,
                pb: 1.5,
                zIndex: 20000,
                backgroundColor: '#616B88',
                borderTopLeftRadius: 50,
                borderBottomLeftRadius: 50,
                cursor: 'pointer',
              }}>
          <ArrowBackIosNewRoundedIcon fontSize={'small'} sx={{color: '#fff', marginTop: 1}}/>
        </Card>
      </Box>
      <LoanAuditTrails openLog={openLog} handleLogClose={handleLogClose} loanId={id}/>
    </PageWrapper>
  );
}